import { useTranslation } from 'react-i18next';
import type { InterventionRoomResponse } from '../../api/generated';
import { Modal } from '../UI';
import { Button } from '../UI/base/Button';
import styles from './DeleteInterventionRoomModal.module.css';

interface DeleteInterventionRoomModalProps {
  room: InterventionRoomResponse;
  onClose: () => void;
  onConfirm: () => void | Promise<void>;
}

export const DeleteInterventionRoomModal = ({
  room,
  onClose,
  onConfirm
}: DeleteInterventionRoomModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal
      title={t('delete-intervention-room-title')}
      onClose={onClose}
      width={480}
      footer={
        <div className={styles.footer}>
          <Button type="secondary" onClick={onClose}>
            {t('delete-intervention-room-cancel')}
          </Button>
          <Button type="primary" onClick={() => void onConfirm()}>
            {t('delete-intervention-room-confirm')}
          </Button>
        </div>
      }
    >
      <p className={styles.message}>
        {t('delete-intervention-room-message', { name: room.description })}
      </p>
    </Modal>
  );
};
